import { MutationTree } from 'vuex';
import {
  DatInstancesState,
  IFilesStatePayload,
  IFile,
  INotification,
  FETCH_DAT_INSTANCES,
  SET_ERROR,
  SET_NOTIFICATION,
  UPDATE_DAT_INSTANCES_STATE
} from './types';

const mutations: MutationTree<DatInstancesState> = {
  [FETCH_DAT_INSTANCES](state: DatInstancesState, payload: IFile[]) {
    state.instances = payload;
  },
  [SET_ERROR](state: DatInstancesState, payload) {
    state.errorMessage = payload;
  },
  [SET_NOTIFICATION](state: DatInstancesState, payload: INotification | undefined) {
    state.notification = payload;
  },
  [UPDATE_DAT_INSTANCES_STATE](
    state: DatInstancesState,
    stateToUpdate: IFilesStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;

    state.datInstancesState[stateKey][view] = stateValue;
  }
};

export default mutations;
